module.exports = __webpack_public_path__ + "img/banner-mob.2e14ff8a.svg";